module.exports = __webpack_public_path__ + "web/img/icon-06.d5dcbaa7.png";